import { PLAYER_LOADED, UPDATE_DURATION, UPDATE_POSITION } from "./actiontypes";

const initialState = (function(state={}) {
	state.duration = state.duration || 0;
	state.position = state.position || 0;
	state.playing = state.playing || false;
	state.loaded = state.loaded || false;
	return state;
})(window.commentstate.player);

export default function(state=initialState, action) {
	switch (action.type) {
		case PLAYER_LOADED:
			return { ...state, loaded: true };
		case UPDATE_DURATION:
			return { ...state, duration: action.duration };
		case UPDATE_POSITION:
			return { ...state, position: action.position };
		default:
			return state;
	}
}